import React, { useState } from 'react';
import { FaBook, FaFileAlt, FaPencilAlt, FaCalendarAlt, FaCheckCircle, FaDownload, FaUserGraduate, FaClipboardList, FaGraduationCap, FaChartLine, FaLightbulb, FaTrophy, FaUsers, FaClock, FaRupeeSign, FaFlask, FaCalculator, FaMicroscope, FaAtom, FaDna, FaStar, FaMedal } from 'react-icons/fa';

const KVPYScholarshipPage = () => {
  const [selectedStream, setSelectedStream] = useState('SA');

  const streamData = {
    'SA': {
      name: "Stream SA (Kishore Vaigyanik Protsahan Yojana)",
      fullName: "For Students in Class XI",
      eligibility: "Students who have just appeared/passed Class X board exam and are joining Class XI with Science subjects",
      ageLimit: "Not more than 17 years as on August 1st",
      icon: <FaFlask />,
      color: "#667eea",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      examPattern: {
        part1: { name: "Part I (Aptitude Test)", marks: 100, duration: "3 Hours", type: "MCQ + Short Answer" },
        part2: { name: "Part II (Interview)", marks: 25, type: "For Selected Candidates" }
      },
      subjects: ["Physics", "Chemistry", "Mathematics", "Biology"],
      fellowship: {
        basic: "₹5,000/month + Annual Contingency Grant ₹20,000",
        period: "During 1st to 3rd year of B.Sc./B.S./B.Stat./B.Math./Int. M.Sc./M.S.",
        enhanced: "₹7,000/month after B.Sc./B.S./B.Stat./B.Math. during M.Sc./4th to 5th year of Int. M.Sc./M.S./M.Math./M.Stat."
      }
    },
    'SX': {
      name: "Stream SX (Kishore Vaigyanik Protsahan Yojana)",
      fullName: "For Students in Class XII",
      eligibility: "Students currently studying in Class XII with Science subjects",
      ageLimit: "Not more than 19 years as on August 1st",
      icon: <FaAtom />,
      color: "#f093fb",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      examPattern: {
        part1: { name: "Part I (Aptitude Test)", marks: 100, duration: "3 Hours", type: "MCQ + Short Answer" },
        part2: { name: "Part II (Interview)", marks: 25, type: "For Selected Candidates" }
      },
      subjects: ["Physics", "Chemistry", "Mathematics", "Biology"],
      fellowship: {
        basic: "₹5,000/month + Annual Contingency Grant ₹20,000",
        period: "During 1st to 3rd year of B.Sc./B.S./B.Stat./B.Math./Int. M.Sc./M.S.",
        enhanced: "₹7,000/month after B.Sc./B.S./B.Stat./B.Math. during M.Sc./4th to 5th year of Int. M.Sc./M.S./M.Math./M.Stat."
      }
    },
    'SB': {
      name: "Stream SB (Kishore Vaigyanik Protsahan Yojana)",
      fullName: "For Students in 1st Year UG",
      eligibility: "Students enrolled in 1st year of B.Sc./B.S./B.Stat./B.Math./Int. M.Sc./M.S. with minimum 60% (50% for SC/ST/PWD) in Class XII",
      ageLimit: "Not more than 20 years as on August 1st (22 years for SC/ST/PWD)",
      icon: <FaDna />,
      color: "#43e97b",
      gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      examPattern: {
        part1: { name: "Part I (Aptitude Test)", marks: 100, duration: "3 Hours", type: "MCQ + Short Answer" },
        part2: { name: "Part II (Interview)", marks: 25, type: "For Selected Candidates" }
      },
      subjects: ["Physics", "Chemistry", "Mathematics", "Biology"],
      fellowship: {
        basic: "₹5,000/month + Annual Contingency Grant ₹20,000",
        period: "During 2nd to 3rd year of B.Sc./B.S./B.Stat./B.Math./Int. M.Sc./M.S.",
        enhanced: "₹7,000/month after B.Sc./B.S./B.Stat./B.Math. during M.Sc./4th to 5th year of Int. M.Sc./M.S./M.Math./M.Stat."
      }
    }
  };

  const benefits = [
    { icon: <FaTrophy />, title: "Monthly Fellowship", desc: "₹5,000 - ₹7,000 per month during study period" },
    { icon: <FaRupeeSign />, title: "Contingency Grant", desc: "Annual grant of ₹20,000 for academic expenses" },
    { icon: <FaGraduationCap />, title: "Career Support", desc: "Direct pathway to research & PhD programs" },
    { icon: <FaMedal />, title: "National Recognition", desc: "Prestigious scholarship by Govt. of India" },
    { icon: <FaBook />, title: "Financial Freedom", desc: "Focus on studies without financial worries" },
    { icon: <FaStar />, title: "Research Opportunities", desc: "Access to top research institutions" }
  ];

  const syllabus = {
    "Physics": [
      "Mechanics: Kinematics, Laws of Motion, Work Energy Power",
      "Gravitation: Universal Law, Planetary Motion",
      "Properties of Matter: Elasticity, Surface Tension",
      "Thermodynamics: Laws of Thermodynamics, Heat Engines",
      "Electrostatics & Current Electricity",
      "Magnetic Effects of Current & Magnetism",
      "Electromagnetic Induction & AC",
      "Optics: Ray Optics, Wave Optics",
      "Modern Physics: Atoms, Nuclei, Semiconductors"
    ],
    "Chemistry": [
      "Physical Chemistry: Atomic Structure, States of Matter",
      "Chemical Bonding & Molecular Structure",
      "Thermodynamics & Thermochemistry",
      "Solutions & Colligative Properties",
      "Chemical Kinetics & Equilibrium",
      "Electrochemistry & Redox Reactions",
      "Organic Chemistry: Basic Principles, Hydrocarbons",
      "Organic Compounds: Alcohols, Phenols, Ethers",
      "Inorganic Chemistry: Periodic Table, s-block, p-block"
    ],
    "Mathematics": [
      "Algebra: Complex Numbers, Sequences & Series",
      "Quadratic Equations & Inequalities",
      "Permutations & Combinations",
      "Binomial Theorem & Mathematical Induction",
      "Matrices & Determinants",
      "Coordinate Geometry: Straight Lines, Circles, Conic Sections",
      "Calculus: Limits, Continuity, Differentiation",
      "Integration & Differential Equations",
      "Vectors & 3D Geometry",
      "Probability & Statistics"
    ],
    "Biology": [
      "Diversity in Living World: Classification",
      "Structural Organization: Cell Biology, Biomolecules",
      "Cell Division: Mitosis, Meiosis",
      "Plant Physiology: Photosynthesis, Respiration",
      "Human Physiology: Digestive, Respiratory, Circulatory Systems",
      "Reproduction in Organisms",
      "Genetics & Evolution: Heredity, DNA",
      "Biology & Human Welfare",
      "Biotechnology Principles",
      "Ecology & Environment"
    ]
  };

  const importantDates = [
    { event: "Online Application Opens", date: "July", note: "KVPY discontinued from 2021, replaced by INSPIRE & other schemes" },
    { event: "Last Date to Apply", date: "September", note: "Check official notifications" },
    { event: "Admit Card Release", date: "October", note: "Download from official portal" },
    { event: "KVPY Aptitude Test", date: "November (Sunday)", note: "Conducted across India" },
    { event: "Answer Key Release", date: "November (Within 2 weeks)", note: "Objection period open" },
    { event: "Result Declaration", date: "December - January", note: "Shortlist for interview" },
    { event: "Interview Round", date: "January - February", note: "For shortlisted candidates" },
    { event: "Final Result", date: "March", note: "Fellowship list announced" }
  ];

  const preparationTips = [
    {
      title: "NCERT Mastery",
      desc: "Complete NCERT Class XI & XII thoroughly with examples",
      icon: <FaBook />
    },
    {
      title: "Conceptual Clarity",
      desc: "Focus on understanding concepts, not just memorization",
      icon: <FaLightbulb />
    },
    {
      title: "Previous Papers",
      desc: "Solve last 10 years KVPY papers multiple times",
      icon: <FaFileAlt />
    },
    {
      title: "Time Management",
      desc: "Practice 3-hour mock tests regularly",
      icon: <FaClock />
    },
    {
      title: "Current Science",
      desc: "Read science journals & recent discoveries",
      icon: <FaMicroscope />
    },
    {
      title: "Interview Prep",
      desc: "Prepare for basic science viva questions",
      icon: <FaUsers />
    }
  ];

  return (
    <div style={{ background: '#f8f9fa', minHeight: '100vh' }}>
      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
        padding: '80px 20px 60px',
        color: 'white',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ fontSize: '4rem', marginBottom: '20px' }}>
            <FaMicroscope />
          </div>
          <h1 style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '20px' }}>
            KVPY Scholarship Program
          </h1>
          <p style={{ fontSize: '1.4rem', marginBottom: '15px', opacity: 0.95 }}>
            Kishore Vaigyanik Protsahan Yojana
          </p>
          <p style={{ fontSize: '1.2rem', marginBottom: '30px', opacity: 0.9 }}>
            National Fellowship Program for Science Students by Department of Science & Technology
          </p>
          <div style={{
            background: 'rgba(255,255,255,0.2)',
            padding: '15px 25px',
            borderRadius: '10px',
            display: 'inline-block',
            marginBottom: '30px'
          }}>
            <p style={{ fontSize: '1.1rem', margin: 0 }}>
              <strong>⚠️ Important Notice:</strong> KVPY has been discontinued from 2021. Replaced by INSPIRE & other fellowship programs.
            </p>
          </div>
          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={() => window.location.href = '/register'}
              style={{
                background: 'white',
                color: '#667eea',
                padding: '15px 40px',
                borderRadius: '30px',
                border: 'none',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-3px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              Enroll for Science Programs
            </button>
            <button
              onClick={() => document.getElementById('syllabus').scrollIntoView({ behavior: 'smooth' })}
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                padding: '15px 40px',
                borderRadius: '30px',
                border: '2px solid white',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.color = '#667eea';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                e.currentTarget.style.color = 'white';
              }}
            >
              View Syllabus
            </button>
          </div>
        </div>
      </div>

      {/* Stream Selection Tabs */}
      <div style={{ 
        background: 'white', 
        padding: '30px 20px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
        position: 'relative',
        top: '0',
        zIndex: 100
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '15px'
          }}>
            {['SA', 'SX', 'SB'].map(stream => (
              <button
                key={stream}
                onClick={() => setSelectedStream(stream)}
                style={{
                  padding: '20px',
                  borderRadius: '12px',
                  border: 'none',
                  background: selectedStream === stream 
                    ? streamData[stream].gradient
                    : '#f0f0f0',
                  color: selectedStream === stream ? 'white' : '#333',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: selectedStream === stream ? `0 4px 15px ${streamData[stream].color}40` : 'none',
                  textAlign: 'left'
                }}
                onMouseEnter={(e) => {
                  if (selectedStream !== stream) {
                    e.currentTarget.style.background = '#e0e0e0';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedStream !== stream) {
                    e.currentTarget.style.background = '#f0f0f0';
                  }
                }}
              >
                <div style={{ fontSize: '2rem', marginBottom: '10px' }}>
                  {streamData[stream].icon}
                </div>
                <div style={{ fontSize: '1.3rem', marginBottom: '5px' }}>
                  Stream {stream}
                </div>
                <div style={{ fontSize: '0.9rem', opacity: selectedStream === stream ? 0.9 : 0.7 }}>
                  {streamData[stream].fullName}
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
        
        {/* Overview Section */}
        <section style={{ marginBottom: '60px' }}>
          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '20px',
            boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
            border: `3px solid ${streamData[selectedStream].color}`
          }}>
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
              <div style={{ 
                fontSize: '3.5rem', 
                color: streamData[selectedStream].color,
                marginBottom: '20px'
              }}>
                {streamData[selectedStream].icon}
              </div>
              
              <h2 style={{ 
                fontSize: '2.5rem', 
                fontWeight: 'bold', 
                marginBottom: '10px',
                color: '#2c3e50'
              }}>
                {streamData[selectedStream].name}
              </h2>
              
              <p style={{ 
                fontSize: '1.2rem',
                color: '#666',
                fontStyle: 'italic'
              }}>
                {streamData[selectedStream].fullName}
              </p>
            </div>

            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '25px'
            }}>
              <div style={{
                padding: '25px',
                background: `${streamData[selectedStream].color}10`,
                borderRadius: '15px',
                border: `2px solid ${streamData[selectedStream].color}30`
              }}>
                <div style={{ fontSize: '2rem', color: streamData[selectedStream].color, marginBottom: '10px' }}>
                  <FaUserGraduate />
                </div>
                <h3 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '10px', color: '#2c3e50' }}>
                  Eligibility
                </h3>
                <p style={{ color: '#666', lineHeight: '1.6', margin: 0, fontSize: '0.95rem' }}>
                  {streamData[selectedStream].eligibility}
                </p>
              </div>

              <div style={{
                padding: '25px',
                background: `${streamData[selectedStream].color}10`,
                borderRadius: '15px',
                border: `2px solid ${streamData[selectedStream].color}30`
              }}>
                <div style={{ fontSize: '2rem', color: streamData[selectedStream].color, marginBottom: '10px' }}>
                  <FaClock />
                </div>
                <h3 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '10px', color: '#2c3e50' }}>
                  Age Limit
                </h3>
                <p style={{ color: '#666', lineHeight: '1.6', margin: 0, fontSize: '0.95rem' }}>
                  {streamData[selectedStream].ageLimit}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            Why KVPY Fellowship?
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '30px'
          }}>
            {benefits.map((benefit, idx) => (
              <div key={idx} style={{
                background: 'white',
                padding: '35px',
                borderRadius: '15px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                border: '2px solid transparent'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = `0 12px 30px ${streamData[selectedStream].color}30`;
                e.currentTarget.style.borderColor = streamData[selectedStream].color;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.08)';
                e.currentTarget.style.borderColor = 'transparent';
              }}>
                <div style={{ 
                  fontSize: '3.5rem',
                  color: streamData[selectedStream].color,
                  marginBottom: '20px'
                }}>
                  {benefit.icon}
                </div>
                <h3 style={{ 
                  fontSize: '1.4rem',
                  fontWeight: 'bold',
                  marginBottom: '15px',
                  color: '#2c3e50'
                }}>
                  {benefit.title}
                </h3>
                <p style={{ 
                  color: '#666',
                  lineHeight: '1.6',
                  margin: 0,
                  fontSize: '1rem'
                }}>
                  {benefit.desc}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Fellowship Details */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaRupeeSign style={{ marginRight: '10px', color: streamData[selectedStream].color }} />
            Fellowship Amount & Duration
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
              gap: '30px'
            }}>
              <div style={{
                padding: '30px',
                background: streamData[selectedStream].gradient,
                borderRadius: '15px',
                color: 'white'
              }}>
                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '20px' }}>
                  Basic Fellowship (B.Sc./B.S./B.Stat./B.Math.)
                </h3>
                <div style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '10px' }}>
                  ₹5,000/month
                </div>
                <div style={{ fontSize: '1.2rem', marginBottom: '15px', opacity: 0.9 }}>
                  + ₹20,000 Annual Contingency Grant
                </div>
                <p style={{ margin: 0, lineHeight: '1.6', opacity: 0.95 }}>
                  {streamData[selectedStream].fellowship.period}
                </p>
              </div>

              <div style={{
                padding: '30px',
                background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
                borderRadius: '15px',
                color: 'white'
              }}>
                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '20px' }}>
                  Enhanced Fellowship (M.Sc./M.S./M.Math./M.Stat.)
                </h3>
                <div style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '10px' }}>
                  ₹7,000/month
                </div>
                <div style={{ fontSize: '1.2rem', marginBottom: '15px', opacity: 0.9 }}>
                  + ₹28,000 Annual Contingency Grant
                </div>
                <p style={{ margin: 0, lineHeight: '1.6', opacity: 0.95 }}>
                  {streamData[selectedStream].fellowship.enhanced}
                </p>
              </div>
            </div>

            <div style={{
              marginTop: '30px',
              padding: '20px',
              background: '#fff3cd',
              borderRadius: '10px',
              border: '1px solid #ffc107'
            }}>
              <p style={{ margin: 0, color: '#856404', fontWeight: '600', lineHeight: '1.6' }}>
                <strong>📌 Total Support:</strong> KVPY fellows receive approximately ₹80,000 - ₹1,00,000 per year during their undergraduate and postgraduate studies, enabling them to focus completely on academics and research.
              </p>
            </div>
          </div>
        </section>

        {/* Exam Pattern */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaClipboardList style={{ marginRight: '10px', color: streamData[selectedStream].color }} />
            Exam Pattern - Stream {selectedStream}
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
              gap: '30px',
              marginBottom: '30px'
            }}>
              <div style={{
                padding: '30px',
                background: `${streamData[selectedStream].color}10`,
                borderRadius: '15px',
                border: `2px solid ${streamData[selectedStream].color}30`
              }}>
                <h3 style={{ 
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  color: streamData[selectedStream].color,
                  marginBottom: '20px'
                }}>
                  {streamData[selectedStream].examPattern.part1.name}
                </h3>
                <div style={{ marginBottom: '15px' }}>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#2c3e50' }}>
                    {streamData[selectedStream].examPattern.part1.marks} Marks
                  </div>
                  <div style={{ color: '#666', marginTop: '5px' }}>Total Marks</div>
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#2c3e50' }}>
                    {streamData[selectedStream].examPattern.part1.duration}
                  </div>
                  <div style={{ color: '#666', marginTop: '5px' }}>Duration</div>
                </div>
                <div>
                  <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#2c3e50' }}>
                    {streamData[selectedStream].examPattern.part1.type}
                  </div>
                  <div style={{ color: '#666', marginTop: '5px' }}>Question Type</div>
                </div>
              </div>

              <div style={{
                padding: '30px',
                background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
                borderRadius: '15px',
                color: '#2c3e50'
              }}>
                <h3 style={{ 
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '20px'
                }}>
                  {streamData[selectedStream].examPattern.part2.name}
                </h3>
                <div style={{ marginBottom: '15px' }}>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold' }}>
                    {streamData[selectedStream].examPattern.part2.marks} Marks
                  </div>
                  <div style={{ marginTop: '5px', opacity: 0.8 }}>Interview Weightage</div>
                </div>
                <div style={{ marginTop: '20px', padding: '15px', background: 'rgba(255,255,255,0.8)', borderRadius: '8px' }}>
                  <p style={{ margin: 0, lineHeight: '1.6', fontSize: '0.95rem' }}>
                    {streamData[selectedStream].examPattern.part2.type}
                  </p>
                </div>
              </div>
            </div>

            <div style={{
              padding: '25px',
              background: '#e3f2fd',
              borderRadius: '10px',
              border: '2px solid #2196f3'
            }}>
              <h4 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '15px', color: '#1565c0' }}>
                📝 Question Paper Structure
              </h4>
              <ul style={{ margin: 0, paddingLeft: '20px', color: '#666' }}>
                <li style={{ marginBottom: '8px' }}>Part I consists of two sections: <strong>Multiple Choice Questions (MCQs)</strong> and <strong>Short Answer Questions</strong></li>
                <li style={{ marginBottom: '8px' }}>MCQs carry <strong>1 mark</strong> each with negative marking of <strong>0.25</strong> marks</li>
                <li style={{ marginBottom: '8px' }}>Short Answer Questions carry <strong>2 marks</strong> each with negative marking of <strong>0.5</strong> marks</li>
                <li>Top performers in Part I are called for <strong>Part II (Interview)</strong> which tests fundamental concepts</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Syllabus Section */}
        <section id="syllabus" style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaBook style={{ marginRight: '10px', color: streamData[selectedStream].color }} />
            Detailed Syllabus - Stream {selectedStream}
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '25px'
          }}>
            {Object.entries(syllabus).map(([subject, topics], idx) => (
              <div key={idx} style={{
                background: 'white',
                padding: '30px',
                borderRadius: '15px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                border: `2px solid ${streamData[selectedStream].color}20`,
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = streamData[selectedStream].color;
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = `0 8px 25px ${streamData[selectedStream].color}20`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = `${streamData[selectedStream].color}20`;
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.08)';
              }}>
                <h3 style={{ 
                  fontSize: '1.5rem', 
                  fontWeight: 'bold', 
                  marginBottom: '20px',
                  color: streamData[selectedStream].color,
                  borderBottom: `3px solid ${streamData[selectedStream].color}`,
                  paddingBottom: '10px'
                }}>
                  {subject}
                </h3>
                <ul style={{ 
                  listStyle: 'none', 
                  padding: 0,
                  margin: 0
                }}>
                  {topics.map((topic, i) => (
                    <li key={i} style={{ 
                      padding: '10px 0',
                      borderBottom: i < topics.length - 1 ? '1px solid #f0f0f0' : 'none',
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '10px',
                      color: '#555',
                      fontSize: '0.95rem'
                    }}>
                      <FaCheckCircle style={{ color: streamData[selectedStream].color, marginTop: '4px', flexShrink: 0 }} />
                      <span>{topic}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* Important Dates */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaCalendarAlt style={{ marginRight: '10px', color: streamData[selectedStream].color }} />
            Important Dates (Reference)
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{ overflow: 'auto' }}>
              <table style={{ 
                width: '100%', 
                borderCollapse: 'collapse',
                fontSize: '1rem'
              }}>
                <thead>
                  <tr style={{ background: streamData[selectedStream].gradient, color: 'white' }}>
                    <th style={{ padding: '15px', textAlign: 'left', borderRadius: '8px 0 0 0' }}>Event</th>
                    <th style={{ padding: '15px', textAlign: 'center' }}>Timeline</th>
                    <th style={{ padding: '15px', textAlign: 'right', borderRadius: '0 8px 0 0' }}>Note</th>
                  </tr>
                </thead>
                <tbody>
                  {importantDates.map((item, idx) => (
                    <tr key={idx} style={{ 
                      background: idx % 2 === 0 ? '#f8f9fa' : 'white',
                      borderBottom: '1px solid #e0e0e0'
                    }}>
                      <td style={{ padding: '15px', fontWeight: '600', color: '#2c3e50' }}>
                        <FaCalendarAlt style={{ marginRight: '10px', color: streamData[selectedStream].color }} />
                        {item.event}
                      </td>
                      <td style={{ padding: '15px', textAlign: 'center', color: '#666' }}>
                        {item.date}
                      </td>
                      <td style={{ padding: '15px', textAlign: 'right', color: '#666', fontSize: '0.9rem' }}>
                        {item.note}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Previous Year Papers */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaFileAlt style={{ marginRight: '10px', color: streamData[selectedStream].color }} />
            Previous Year Question Papers
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
              gap: '20px'
            }}>
              {['2020', '2019', '2018', '2017', '2016', '2015'].map((year) => (
                <button key={year} style={{
                  padding: '25px',
                  borderRadius: '12px',
                  border: '2px solid #e8e8e8',
                  background: 'white',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  color: '#2c3e50',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = streamData[selectedStream].gradient;
                  e.currentTarget.style.color = 'white';
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(-5px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = '#2c3e50';
                  e.currentTarget.style.borderColor = '#e8e8e8';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}>
                  <span>KVPY {year} - {selectedStream}</span>
                  <FaDownload />
                </button>
              ))}
            </div>
            <p style={{ 
              textAlign: 'center', 
              marginTop: '30px',
              color: '#666',
              fontSize: '1rem'
            }}>
              Download previous year papers with detailed solutions
            </p>
          </div>
        </section>

        {/* Preparation Tips */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaLightbulb style={{ marginRight: '10px', color: streamData[selectedStream].color }} />
            Preparation Strategy for KVPY / INSPIRE
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px'
            }}>
              {preparationTips.map((tip, idx) => (
                <div key={idx} style={{
                  padding: '25px',
                  border: '2px solid #e8e8e8',
                  borderRadius: '12px',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = streamData[selectedStream].color;
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = `0 8px 20px ${streamData[selectedStream].color}20`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e8e8e8';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  <div style={{ 
                    fontSize: '2.5rem',
                    color: streamData[selectedStream].color,
                    marginBottom: '15px'
                  }}>
                    {tip.icon}
                  </div>
                  <h4 style={{ 
                    fontSize: '1.3rem',
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    color: '#2c3e50'
                  }}>
                    {tip.title}
                  </h4>
                  <p style={{ 
                    color: '#666',
                    lineHeight: '1.6',
                    margin: 0
                  }}>
                    {tip.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Course Packages */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaRupeeSign style={{ marginRight: '10px', color: streamData[selectedStream].color }} />
            KVPY Preparation Course Packages
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '30px'
          }}>
            {[
              {
                name: "Foundation Course",
                price: "7,999",
                duration: "4 Months",
                features: [
                  "Complete Subject Coverage",
                  "NCERT Based Study Material",
                  "15 Mock Tests",
                  "Video Lectures (PCM/PCB)",
                  "Doubt Clearing Sessions"
                ],
                gradient: streamData[selectedStream].gradient
              },
              {
                name: "Advanced Course",
                price: "12,999",
                duration: "6 Months",
                features: [
                  "Everything in Foundation",
                  "Live Interactive Classes",
                  "30+ Mock Tests + Analysis",
                  "Previous 10 Years Papers",
                  "Interview Preparation",
                  "Personal Mentor Support"
                ],
                gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                popular: true
              },
              {
                name: "Complete Package",
                price: "18,999",
                duration: "12 Months",
                features: [
                  "Everything in Advanced",
                  "One-on-One Mentoring",
                  "Unlimited Mock Tests",
                  "Current Science Updates",
                  "Research Paper Reading",
                  "Science Journal Access",
                  "24/7 Premium Support"
                ],
                gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
              }
            ].map((pkg, idx) => (
              <div key={idx} style={{
                background: 'white',
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: pkg.popular ? '0 12px 40px rgba(102,126,234,0.3)' : '0 4px 15px rgba(0,0,0,0.08)',
                border: pkg.popular ? '3px solid #667eea' : '1px solid #e8e8e8',
                position: 'relative',
                transform: pkg.popular ? 'scale(1.05)' : 'scale(1)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = pkg.popular ? 'scale(1.08)' : 'scale(1.03)';
                e.currentTarget.style.boxShadow = '0 15px 45px rgba(102,126,234,0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = pkg.popular ? 'scale(1.05)' : 'scale(1)';
                e.currentTarget.style.boxShadow = pkg.popular ? '0 12px 40px rgba(102,126,234,0.3)' : '0 4px 15px rgba(0,0,0,0.08)';
              }}>
                {pkg.popular && (
                  <div style={{
                    position: 'absolute',
                    top: '20px',
                    right: '-35px',
                    background: '#FFD700',
                    color: '#333',
                    padding: '5px 40px',
                    fontSize: '0.85rem',
                    fontWeight: 'bold',
                    transform: 'rotate(45deg)',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                    zIndex: 1
                  }}>
                    POPULAR
                  </div>
                )}
                
                <div style={{
                  background: pkg.gradient,
                  padding: '40px 30px',
                  textAlign: 'center',
                  color: 'white'
                }}>
                  <h3 style={{ 
                    fontSize: '1.8rem',
                    fontWeight: 'bold',
                    marginBottom: '15px'
                  }}>
                    {pkg.name}
                  </h3>
                  <div style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '10px' }}>
                    ₹{pkg.price}
                  </div>
                  <div style={{ fontSize: '1.1rem', opacity: 0.9 }}>
                    {pkg.duration}
                  </div>
                </div>

                <div style={{ padding: '30px' }}>
                  <ul style={{ 
                    listStyle: 'none',
                    padding: 0,
                    margin: '0 0 25px 0'
                  }}>
                    {pkg.features.map((feature, i) => (
                      <li key={i} style={{
                        padding: '12px 0',
                        borderBottom: i < pkg.features.length - 1 ? '1px solid #f0f0f0' : 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        color: '#555'
                      }}>
                        <FaCheckCircle style={{ color: '#43e97b', fontSize: '1.2rem', flexShrink: 0 }} />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <button style={{
                    width: '100%',
                    padding: '15px',
                    borderRadius: '10px',
                    border: 'none',
                    background: pkg.gradient,
                    color: 'white',
                    fontSize: '1.1rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => window.location.href = '/register'}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                    Enroll Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FAQs */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            Frequently Asked Questions
          </h2>

          <div style={{
            background: 'white',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
            overflow: 'hidden'
          }}>
            {[
              {
                q: "Is KVPY still active?",
                a: "KVPY was discontinued from 2021. However, the Government of India has introduced alternative fellowship programs like INSPIRE for science students. The syllabus and preparation strategy remain relevant for these programs."
              },
              {
                q: "What is the difference between SA, SX, and SB streams?",
                a: "SA is for Class 11 students, SX is for Class 12 students, and SB is for 1st year undergraduate students. Each stream has different eligibility criteria and exam difficulty levels."
              },
              {
                q: "How much fellowship do KVPY scholars receive?",
                a: "KVPY fellows received ₹5,000/month during B.Sc. (1st to 3rd year) and ₹7,000/month during M.Sc., along with annual contingency grants of ₹20,000-₹28,000."
              },
              {
                q: "What was the selection process for KVPY?",
                a: "The selection had two stages: Part I (Aptitude Test with 100 marks) and Part II (Interview with 25 marks). Only candidates who cleared the written test were called for interviews."
              },
              {
                q: "Can I prepare for other exams along with KVPY?",
                a: "Yes! KVPY preparation significantly helps in JEE Advanced, NEET, and other science entrance exams as it focuses on conceptual understanding and problem-solving."
              },
              {
                q: "What subjects are tested in KVPY?",
                a: "KVPY tests Physics, Chemistry, Mathematics, and Biology. The questions are based on Class XI and XII NCERT syllabus with emphasis on application and analytical thinking."
              },
              {
                q: "What is the replacement for KVPY?",
                a: "The INSPIRE (Innovation in Science Pursuit for Inspired Research) program by DST and other fellowship schemes have replaced KVPY for encouraging science students."
              },
              {
                q: "Is NCERT enough for KVPY preparation?",
                a: "NCERT is the foundation, but you need to solve previous KVPY papers, practice advanced problems, and read current science developments for comprehensive preparation."
              }
            ].map((faq, idx) => (
              <div key={idx} style={{
                padding: '30px',
                borderBottom: idx < 7 ? '1px solid #e8e8e8' : 'none'
              }}>
                <h4 style={{ 
                  fontSize: '1.3rem',
                  fontWeight: 'bold',
                  marginBottom: '15px',
                  color: streamData[selectedStream].color,
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px'
                }}>
                  <span style={{ flexShrink: 0 }}>Q{idx + 1}.</span>
                  <span>{faq.q}</span>
                </h4>
                <p style={{ 
                  color: '#666',
                  lineHeight: '1.8',
                  margin: '0 0 0 35px',
                  fontSize: '1.05rem'
                }}>
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Final CTA */}
        <section>
          <div style={{
            background: streamData[selectedStream].gradient,
            padding: '60px 40px',
            borderRadius: '20px',
            textAlign: 'center',
            color: 'white'
          }}>
            <div style={{ fontSize: '4rem', marginBottom: '20px' }}>
              <FaMicroscope />
            </div>
            <h2 style={{ 
              fontSize: '2.5rem',
              fontWeight: 'bold',
              marginBottom: '20px'
            }}>
              Start Your Science Journey
            </h2>
            <p style={{ 
              fontSize: '1.3rem',
              marginBottom: '35px',
              opacity: 0.95,
              maxWidth: '700px',
              margin: '0 auto 35px'
            }}>
              Join our comprehensive science program and prepare for future fellowship opportunities
            </p>
            <div style={{ 
              display: 'flex',
              gap: '20px',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <button 
                onClick={() => window.location.href = '/register'}
                style={{
                  background: 'white',
                  color: streamData[selectedStream].color,
                  padding: '18px 45px',
                  borderRadius: '30px',
                  border: 'none',
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
                }}>
                Register for Science Program
              </button>
              <button style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                padding: '18px 45px',
                borderRadius: '30px',
                border: '2px solid white',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onClick={() => window.location.href = '/contact'}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.color = streamData[selectedStream].color;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                e.currentTarget.style.color = 'white';
              }}>
                Get Expert Guidance
              </button>
            </div>
          </div>
        </section>
      </div>

      {/* Footer Note */}
      <div style={{
        background: '#2c3e50',
        color: 'white',
        padding: '30px 20px',
        textAlign: 'center',
        marginTop: '60px'
      }}>
        <p style={{ margin: '0 0 10px', fontSize: '1.1rem' }}>
          © 2025 Olewin Academy - All Rights Reserved
        </p>
        <p style={{ margin: 0, opacity: 0.8 }}>
          For official information about fellowship programs, visit: <a href="https://www.dst.gov.in" target="_blank" rel="noopener noreferrer" style={{ color: '#43e97b', textDecoration: 'none' }}>Department of Science & Technology</a>
        </p>
      </div>
    </div>
  );
};

export default KVPYScholarshipPage;